import { IUserCredentialsModel } from "../interfaces/model";

// Initial Values for Login
export const INIT_VALUES_LOGIN: IUserCredentialsModel = {
    username: "",
    password: "",
};
